import $ from 'jquery';
import Promise from 'bluebird';
import _ from 'underscore';
import { useEffect } from 'react';

import { useAction } from './hooks/use-data-actions';
import { useCache } from './context/cache-context';
import type {
  CCDataServerContext,
  EntityId,
  TermsAndConditionsResponse,
} from './types';

class TermsAndConditionsDomainActions {
  cid: EntityId;
  uid: EntityId;

  constructor({
    CurrentCustomer,
    CurrentUser
  }: CCDataServerContext) {
    this.cid = CurrentCustomer && CurrentCustomer.Id;
    this.uid = CurrentUser && CurrentUser.Id;
  }

  fetch = (country: string, isUp: boolean, isUpSwitchToSmart?: boolean) => {
    const antiForgeryToken = $('input[name="__RequestVerificationToken"]').val();
    // use "/smart/signup" API to ensure it routes through smart campaigns signup controller
    const prefix = isUp || !isUpSwitchToSmart ? '' : '/smart';
    // Add &upse=true to make sure routing to UnifiedProductSignupController.cs
    const suffix = isUp ? '&upse=true' : '';
    return Promise.resolve($.ajax({
      url: `${prefix}/Signup/AggreementOptions?countryCode=${encodeURIComponent(country)}&uid=${this.uid}&cid=${this.cid}${suffix}&__RequestVerificationToken=${antiForgeryToken}`,
      type: 'get',
      dataType: 'json',
    }) as PromiseLike<TermsAndConditionsResponse>);
  };
}

export const useTermsAndConditions = (
  country: string,
  serverContext: CCDataServerContext,
  isUp = false
) => {
  const { cache, tryUpdate } =
    useCache<Record<string, TermsAndConditionsResponse>>('termsAndConditions');
  const domainActions = useAction(TermsAndConditionsDomainActions, serverContext);

  useEffect(() => {
    if (country && (_.isUndefined(cache) || _.isUndefined(cache[country])) && domainActions) {
      tryUpdate(() => domainActions.fetch(
        country,
        isUp,
        serverContext
        && serverContext.CCUIPilots
        && serverContext.CCUIPilots.isUnifiedProductSwitchToSmartEnabled
      )
        .then(data => ({
        ...cache,
        [country]: data
      })));
    }
  }, [domainActions, cache, tryUpdate, country, isUp, serverContext]);

  return cache && cache[country];
};
